import type { InputHTMLAttributes, ReactNode } from "react";
import "./selection.css";

type ChoiceProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "children"> & { label: ReactNode };

export function ChoiceChip({ label, className = "", ...props }: ChoiceProps) {
  return <label className={`ui-choice-chip ${className}`.trim()}><input {...props} type="checkbox" /><span>{label}</span></label>;
}

/** Fixed label/track space prevents layout movement when the value changes. */
/* label을 안 주면 스위치만 선다 — 켜짐/꺼짐처럼 스위치가 이미 말하고 있는 것을 글로 한 번
   더 적을 이유가 없는 자리가 있다. 그때 읽어 줄 이름은 aria-label이 맡는다. */
export function Switch({ label, checked, className = "", ...props }: Omit<ChoiceProps, "label"> & { label?: ReactNode }) {
  return <label className={`ui-switch${label === undefined ? " ui-switch--bare" : ""} ${className}`.trim()}><input {...props} type="checkbox" role="switch" checked={checked} />{label !== undefined && <span>{label}</span>}<i aria-hidden="true" /></label>;
}
